define('modules/accounts/status/products/mdirector/balance/transfer/result/view',['require','exports','module','views/BaseView','jquery','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");
    var $ = require("jquery");

    var View = BaseView.extend({
        template: require("ldsh!./template"),
        initialize: function() {
            if (this.model) {
                this.listenTo(this.model, "sync request error", this.render);
            }
        },
        serialize: function(){
            return {
                model: this.model,
                responseOk: this.responseOk
            };
        },
        setResponseOk: function(response) {
            this.responseOk = response;
        }
    });
    module.exports = View;
});

